import { render } from "./ViolationCountBySeverityWidget.vue?vue&type=template&id=1e5d9484&scoped=true"
import script from "./ViolationCountBySeverityWidget.vue?vue&type=script&lang=js"
export * from "./ViolationCountBySeverityWidget.vue?vue&type=script&lang=js"

import "./ViolationCountBySeverityWidget.vue?vue&type=style&index=0&id=1e5d9484&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e5d9484"]])

export default __exports__